<template>
    <div class="invoice" id="detail-tagihan">
        <SOSlotBase :bg-grey="false">
            <template v-slot:title-bar>
                <SOTitleBar :type="'back'" :page-title="page.title" @back="back" />
            </template>
            <template v-slot:content>
                <div class="p-x-20 f-reg-black f-14" style="position: relative;">
                    <div class="resume m-t-16 m-d-16">
                        <div class="d-flex-between-center">
                            <label class="m-d-0 f-c-midgrey">Jumlah Transaksi:</label>
                            <label class="m-d-0">{{ dataTagihan.countTransaksi | decimal }} Transaksi</label>
                        </div>
                        <div class="d-flex-between-center">
                            <label class="m-d-0 f-c-midgrey">Total Transaksi:</label>
                            <label class="m-d-0">Rp {{ dataTagihan.grandtotal | decimal }}</label>
                        </div>
                    </div>
                    <p class="m-d-16 f-c-midgrey">Terdapat {{ dataTagihan.countTransaksi | decimal }} transaksi dalam invoice ini.</p>
                    <diV class="m-d-16">
                        <div
                            v-for="(tagihans, idx) in getTagihans"
                            :key="`${tagihans.key}-tagihan`"
                            class="list-tagihan m-d-16"
                            @click="expandData(tagihans.key)"
                        >
                            <SODetailExpand
                                :ref="`tagihan${idx}`"
                                :id="`data-tagihan-${idx}`"
                                :full-height="fullHeight(tagihans)"
                                :expanded="tagihans.key === expandKey"
                                :disable-toggle-expand="false"
                            >
                                <template v-slot:custom-header>
                                    <div class="d-flex-between-center custom-head">
                                        <div>
                                            <p class="m-d-0" v-if="$moment(tagihans.key).isValid()">
                                                {{ $moment(tagihans.key).format("dddd, Do MMM YYYY") }}
                                            </p>
                                            <p class="m-d-0" v-else>
                                                {{ tagihans.key }}
                                            </p>

                                            <p class="m-d-0">
                                                {{ tagihans.countTransaksi }} Transaksi • Rp {{ tagihans.grandtotal | decimal }}
                                            </p>
                                        </div>
                                        <div
                                            :class="{
                                                rotate_icon_180: isExpand(`tagihan${idx}`),
                                                rotate_icon_0: !isExpand(`tagihan${idx}`),
                                            }"
                                        >
                                            <SOIconBase view-box="0 0 16 16" width="20" height="20">
                                                <template v-slot:icon>
                                                    <ChevronRight1616 />
                                                </template>
                                            </SOIconBase>
                                        </div>
                                    </div>
                                </template>
                                <template v-slot:content>
                                    <div class="list-item-tagihan f-reg-black f-14">
                                        <CardTagihan :data-list="tagihans.transaksi" />
                                    </div>
                                </template>
                            </SODetailExpand>
                        </div>
                    </diV>
                </div>
            </template>
        </SOSlotBase>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import resulter from "@/store/utils/resulter";
import { moduleName } from "../store/state";

import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SODetailExpand from "@/so-components/global/ui/SODetailExpand";

import SOIconBase from "@/so-components/global/icons/SOIconBase.vue";
import ChevronRight1616 from "@/so-components/global/icons/iconPacks/ChevronRight1616.vue";

import CardTagihan from "../components/CardTagihan.vue";

export default {
    name: "DetailTagihan",
    components: {
        SOSlotBase,
        SOTitleBar,
        SODetailExpand,
        SOIconBase,
        ChevronRight1616,
        CardTagihan,
    },
    data() {
        return {
            page: { title: "Detail Tagihan", loading: false },
            expandKey: null,
            dataTagihan: {},
        };
    },
    mounted() {
        this.init();
    },
    computed: {
        ...mapGetters(moduleName, {
            konsumenList: "konsumenList",
            konsumenTotal: "konsumenTotal",
            imageStore: "imageStore",
            groupBy: "groupBy",
        }),
        idInvoice() {
            return this.$route.params.invoiceId;
        },
        isExpand() {
            return (refs) => {
                let ref = this.$refs[refs];
                return ref ? ref[0].isExpand : false;
            };
        },
        fullHeight() {
            return function(items) {
                return 92 * items.length;
            };
        },
        getTagihans() {
            return this.dataTagihan.dataTransaksi;
        },
        geTotal() {
            return (data) => {
                let total = 0;
                data.forEach((data) => {
                    total += data.total;
                });

                return total;
            };
        },
    },
    methods: {
        ...mapActions({
            getDetailTagihan: `${moduleName}/getDetailTagihan`,
        }),
        init() {
            console.log("object");
            this.setFetching(true);
            this.getDetailTagihan({ idInvoice: this.idInvoice })
                .then((res) => {
                    if (!res.data) {
                        this.$toast.error(res);
                    } else {
                        let { code, data, msg, status } = res.data;
                        if (code === 200 && status) {
                            this.dataTagihan = data;
                            this.expandKey = data.dataTransaksi[0].key;
                        } else {
                            this.$toast.error(msg);
                        }
                    }
                    this.setFetching(false);
                })
                .catch((e) => {
                    this.setFetching(false);

                    this.$toast.error(e);
                });
        },
        setFetching(val) {
            this.page.loading = val;
        },
        back() {
            this.$router.go(-1);
        },
        expandData(val) {
            this.expandKey = val;
        },
    },
};
</script>
<style scoped src="../static/style.css"></style>
<style scoped>
.custom-head {
    padding: 16px;
    background-color: #f2f5f7;
}
</style>
